import { Badge, BodyText, Icons, Tooltip } from "@/components/ui";
import type { AllergyIntolerance } from "@curai/js-fhir-tools";
import { AllergyIntolerance as AllergyIntoleranceClass } from "@curai/js-fhir-tools";
import { memo } from "react";
import { COPY_SAFE_UNDERLINE } from "../constants";

export const AllergiesNKADisplay = () => (
  <BodyText textColor="info" size="sm">
    <Tooltip side="bottom" tooltipContentText="No Known Allergies">
      <span className={COPY_SAFE_UNDERLINE}>NKA</span>
    </Tooltip>
  </BodyText>
);

export const AllergiesCountDisplay = ({
  allergies,
}: { allergies: AllergyIntolerance[] }) => (
  <BodyText textColor="warning" size="sm">
    <Tooltip
      side="bottom"
      tooltipContentComponent={<AllergyTooltip allergies={allergies} />}
    >
      <span className={COPY_SAFE_UNDERLINE}>
        {`${allergies.length > 1 ? `${allergies.length} Allergies` : "1 Allergy"}`}
      </span>
    </Tooltip>
  </BodyText>
);

const AllergyTooltip = memo(
  ({ allergies }: { allergies: AllergyIntolerance[] }) => {
    return (
      <div className="flex flex-col gap-1">
        {allergies.map((allergy) => {
          return (
            <BodyText className="text-white" key={allergy?.id} size="sm">
              {new AllergyIntoleranceClass(allergy).allergyName}
            </BodyText>
          );
        })}
      </div>
    );
  },
);

export const AllergiesErrorDisplay = () => (
  <Badge variant="error">
    <Icons.Pill className="h-2 w-2 stroke-error" />
    <BodyText textColor="error" size="sm">
      <Tooltip side="bottom" tooltipContentText="Unable to load allergies">
        <span className={COPY_SAFE_UNDERLINE}>Allergies Unavailable</span>
      </Tooltip>
    </BodyText>
  </Badge>
);

// TODO(Jaffe): Checking if this needs a tooltip
export const AllergiesNotChartedDisplay = () => (
  <Badge variant="error-contrast">
    <Icons.Pill className="h-2 w-2 stroke-white" />
    <BodyText textColor="white" size="sm">
      <Tooltip
        side="bottom"
        tooltipContentText="Allergies Unknown: Confirm with patient"
      >
        <span>Unknown</span>
      </Tooltip>
    </BodyText>
  </Badge>
);
